/**
 * popupMedia
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_download-media.scss';

// Module template
import './_download-media.twig';

export const name = 'downloadMedia';
const FOCUS_CLASS = 'is-focussed';

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context) {
  const $downloadMediaLinks = $('.download-media', $context);
  const unfocusAll = () =>
    $downloadMediaLinks.find('a').removeClass(FOCUS_CLASS);

  $downloadMediaLinks.each(function eachDownloadMediaElFn() {
    const $a = $(this).find('a');
    const label = $(this).data('downloadMediaLabel');
    const focus = () => $a.addClass(FOCUS_CLASS);
    const unfocus = () => $a.removeClass(FOCUS_CLASS);
    const isFocussed = () => $a.hasClass(FOCUS_CLASS);

    $a.attr(
      'download',
      $a
        .attr('href')
        .split('/')
        .pop()
    );

    $a.append(
      $('<span />')
        .text(label)
        .addClass('download-media__label btn btn-primary')
    );

    // Touch device effect
    if ('ontouchstart' in window) {
      $a.click(() => {
        // Is already focussed, go ahead ...
        if (isFocussed()) {
          return true;
        }

        // Not focussed, unfocus all others and prevent the click
        unfocusAll();
        focus();
        return false;
      });
    } else {
      // Desktop hovering effect
      $a.mouseenter(focus).mouseleave(unfocus);
    }
  });
}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};